const getDailyViewSums = (pageViewsList) => pageViewsList
  .reduce((acc, item) => {
    const date = item.reportDate

    if (!acc[date]) {
      acc[date] = {
        viewerQuantity: 0,
        addCartUserQuantity: 0,
        viewTime: 0
      }
    }

    acc[date].viewerQuantity += item.viewerQuantity
    acc[date].addCartUserQuantity += item.addCartUserQuantity
    acc[date].viewTime += item.viewTime

    return acc
  }, {})

export const getSellerSaleStateMapByTimeDuration = (pageViewData, saleStateMapByTimeDuration = {}) => {
  const targetMap = saleStateMapByTimeDuration.day || {}
  const dailyViewSums = getDailyViewSums(pageViewData)

  Object.keys(dailyViewSums).forEach(date => {
    if (targetMap[date]) {
      targetMap[date] = {
        ...targetMap[date],
        ...dailyViewSums[date]
      }
    }
  })
  return {
    ...saleStateMapByTimeDuration,
    day: targetMap
  }
}
